<div class="modal-container">
    <!-- Modal Header -->
    <header class="modal-header">
        <h2 class="modal-title">{{ title() }}</h2>
        <button mat-icon-button (click)="onClose()" class="close-button" [disabled]="closeDisabled()"
            [attr.aria-label]="'Cerrar modal' | translate">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <!-- Modal Body/Content -->
    <div class="modal-body">
        <ng-content></ng-content>
    </div>

    <!-- Modal Footer -->
    @if (primaryBtnLabel() || secondaryBtnLabel()) {
    <footer class="modal-footer">
        @if (secondaryBtnLabel()) {
        <button mat-stroked-button (click)="onSecondaryClick()" [disabled]="secondaryBtnDisabled()"
            class="btn-secondary">
            @if (secondaryBtnIcon()) {
            <mat-icon>{{ secondaryBtnIcon() }}</mat-icon>
            }
            <span>{{ secondaryBtnLabel() }}</span>
        </button>
        }

        @if (primaryBtnLabel()) {
        <button mat-flat-button (click)="onPrimaryClick()" [disabled]="primaryBtnDisabled()" class="btn-primary">
            @if (primaryBtnIcon()) {
            <mat-icon>{{ primaryBtnIcon() }}</mat-icon>
            }
            <span>{{ primaryBtnLabel() }}</span>
        </button>
        }
    </footer>
    }
</div>